import { render, staticRenderFns } from "./Category_list.vue?vue&type=template&id=71844379&scoped=true&"
import script from "./Category_list.vue?vue&type=script&lang=js&"
export * from "./Category_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71844379",
  null
  
)

export default component.exports